import { useCallback, useMemo } from 'react';
import { Box, Tab, TabList, Tabs } from '~/commonComponents';
import { CandidateStatus, CandidateStatusMapper } from '~/domain/PermanentJobs';

type TShowAbleCandidateStatus = Exclude<CandidateStatus, CandidateStatus.Cancelled>;

interface ICandidateStatusFilterPanelProps {
  counts: Record<TShowAbleCandidateStatus, number> & { all: number };
  onChange(tab: CandidateStatus | 'all'): void;
}

export const CandidateStatusFilterPanel = ({
  counts,
  onChange,
}: ICandidateStatusFilterPanelProps) => {
  const tabs = useMemo(
    () => [
      CandidateStatus.Applied,
      CandidateStatus.Scheduled,
      CandidateStatus.Interviewed,
      CandidateStatus.Rejected,
      CandidateStatus.Hired,
    ],
    [],
  );

  const handleTabChange = useCallback(
    (idx: number) => {
      onChange(tabs[idx - 1] || 'all');
    },
    [onChange, tabs],
  );

  return (
    <Tabs
      tabListStyle={{ gap: 16, marginBottom: 8 }}
      style={{ alignItems: 'flex-start' }}
      onChangeTab={handleTabChange}
    >
      <TabList>
        <Tab
          title={`All${counts.all > 0 ? ` (${counts.all})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {tabs.map((it) => (
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={CandidateStatusMapper.getColor(it)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            key={it}
            title={`${CandidateStatusMapper.toHumanReadable(it)}${counts[it as TShowAbleCandidateStatus] > 0 ? ` (${counts[it as TShowAbleCandidateStatus]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
